export default __webpack_public_path__ + "static/media/mobile.11dbc51f.png";